import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import moment from 'moment'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T1037StudentHandleImageService.C40421_doBrowse', input: {}},
    getStudentList: { api: 'T1010StudentBasicService.C40501_getStudentList', input: {}},
    getAdvisorList: { api: 'T0010UsersService.getAdvisorsDropdown', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    orderBy: {
      order_schedule_date: 'desc',
      order_time_limit_no: 'desc',
    },
    studentList: [],
    advisorList: [],

    errorMessage: {},
  },

  getters: {},

  mutations: {},

  actions: {
    async initState ({ state }) {
      const res = await ApiUtils.postData({
        data: [
          PageConst.ACTION.getAdvisorList,
        ]
      }, false)
      state.advisorList = res[0].output
    },
    async getStudentList ({ state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { ...PageConst.ACTION.getStudentList, input: payload  },
        ]
      }, false)
      state.studentList = res[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
